import { getImage } from "@/app/core-module/util/coreHelper";

import certificateDefaultBackground from "./user-module/assets/images/certificate-background.jpg";
import cardBackground from "./user-module/assets/images/card-background.jpg";

//region 5m
import certificateBackground5m from "./user-module/assets/images/5m/background.png";
import certificateOrg1 from "./user-module/assets/images/5m/c1.png";
import certificateOrg2 from "./user-module/assets/images/5m/c2.png";
import certificateOrg4 from "./user-module/assets/images/5m/c4.png";
import certificateOrg5 from "./user-module/assets/images/5m/c5.png";
import certificateOrg6 from "./user-module/assets/images/5m/c6.png";
import certificateOrg7 from "./user-module/assets/images/5m/c7.png";
import certificateOrg8 from "./user-module/assets/images/5m/c8.png";
import certificateOrg10 from "./user-module/assets/images/5m/c10.png";
import certificateSeal5m from "./user-module/assets/images/5m/seal.png";
import certificateOnlineTrainerSign5m from "./user-module/assets/images/5m/onlineTrainerSign.png";
import certificateMdSignature5m from "./user-module/assets/images/5m/mdSign.png";
import cardBackground5m from "./user-module/assets/images/5m/card-background.png";
//endregion

export const EnvSubscriberHelper = {
  getEnvCertificateRelatedValues: ({ trainingCertificate, imageCacheParam = 1 } = {}) => {
    const trainingMode = trainingCertificate?.trainingMode;
    const trainerName = trainingCertificate?.trainerName ?? "";
    const latestTrainerSignature =
      trainingCertificate?.trainer?.signature ||
      trainingCertificate?.trainer?.user?.avatar;

    const fallbackSignature = trainingCertificate?.trainerSignature;

    const finalSignature = latestTrainerSignature || fallbackSignature;

    const trainerSignature =
      getImage(finalSignature, {
        params: `?r=${Date.now()}`, // cache fix
      }) ?? "";

  //  const trainerSignature =
  //     getImage(trainingCertificate?.trainerSignature, {
  //       params: `?r=${imageCacheParam}`,
  //     }) ?? "";

    const is5mSubscriber = process.env.VUE_APP_SUBSCRIBER === "5M";
    if (is5mSubscriber) {
      return {
        certificateBackground: null, //certificateBackground5m,
        subscriberContact:
          "Email: info@5m-int.com/Web. www.5m-int.com/Tel: +956 6606 6346",
        subscriberApprovalRef: "KPC Approval Ref:  PQC-24-June-0004",
        trainerName:
          trainingMode === "ONLINE"
            ? "Sanuj Naimanapparambu Subair"
            : trainerName,
        trainerSignature:
          trainingMode === "ONLINE"
            ? certificateOnlineTrainerSign5m
            : trainerSignature,
        managingDirectorName: "Hamad Al Mutairi",
        mdSignature: certificateMdSignature5m,
        orgLogos: [
          certificateOrg1,
          certificateOrg2,
          certificateOrg4,
          certificateOrg5,
          certificateOrg6,
          certificateOrg7,
          certificateOrg8,
          certificateOrg10,
        ],
        certificateSeal: certificateSeal5m,
      };
    }

    return {
      certificateBackground: null, //certificateDefaultBackground,
      subscriberContact: "",
      subscriberApprovalRef: "",
      trainerName: trainingMode === "ONLINE" ? "" : trainerName,
      trainerSignature: trainingMode === "ONLINE" ? "" : trainerSignature,
      managingDirectorName: "",
      mdSignature: "",
      orgLogos: [],
      certificateSeal: null,
    };
  },
  getEnvAttendanceRelatedValues: () => {
    const is5mSubscriber = process.env.VUE_APP_SUBSCRIBER === "5M";

    if (is5mSubscriber) {
      return {
        refNumber: "5M-TR-F1 Attendance Sheet",
        revision: "Revision 2",
        orgLogos: [
          certificateOrg1,
          certificateOrg2,
          certificateOrg4,
          certificateOrg5,
          certificateOrg6,
          certificateOrg7,
          certificateOrg8,
          certificateOrg10,
        ],
      };
    }

    return {
      refNumber: "",
      revision: "",
      orgLogos: [],
    };
  },
  getEnvProfileCardRelatedValues: () => {
    const is5mSubscriber = process.env.VUE_APP_SUBSCRIBER === "5M";

    if (is5mSubscriber) {
      return {
        cardBackground: cardBackground5m,
        subscriberContact:
          "Email: info@5m-int.com/Web. www.5m-int.com/Tel: +956 6606 6346",
      };
    }

    return {
      cardBackground: cardBackground,
      subscriberContact: "",
    };
  },
};
